// extracted by mini-css-extract-plugin
export var deleteIcon = "_pv-5";
export var deleteOption = "_pv-3";
export var divider = "_pv-2";
export var downloadIcon = "_pv-4";
export var drawer = "_pv-0";
export var drawerFooter = "_pv-6";
export var drawerOpen = "_pv-1";
export var highlighted = "_pv-7";
export var lighterHighlight = "_pv-8";